module.exports = __webpack_public_path__ + "img/maxx_cursor_nobg.f9fced64.png";